import api from '../utils/api';

// Fetch all enrollments
export const getAllEnrollments = async (headers) => {
  try {
    const response = await api.get('/api/enrollments', headers);
    console.log("enrollments", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching enrollments:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific enrollment by ID
export const getEnrollmentById = async (id, headers) => {
  try {
    const response = await api.get(`/api/enrollments/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error fetching enrollment with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new enrollment
export const createEnrollment = async (enrollmentData, headers) => {
  try {
    const response = await api.post('/api/enrollments', enrollmentData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating enrollment:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing enrollment
export const updateEnrollment = async (id, enrollmentData, headers) => {
  try {
    const response = await api.put(`/api/enrollments/${id}`, enrollmentData,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error updating enrollment with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete an enrollment
export const deleteEnrollment = async (id, headers) => {
  try {
    const response = await api.delete(`/api/enrollments/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error deleting enrollment with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
